import { useMemo } from 'react'

import { get } from 'lodash'
import { useSelector, useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'

import actGetListRoutePointRegister from '~/modules/master/redux/actions/route-point-register'

const useRoutePointRegister = () => {
  const data = useSelector((state) => get(state, 'master.routePointRegister'))
  const dispatch = useDispatch()
  const actions = useMemo(
    () => bindActionCreators(actGetListRoutePointRegister, dispatch),
    [dispatch],
  )
  return {
    actions,
    data,
  }
}

export default useRoutePointRegister 